import { render, staticRenderFns } from "./reportOweFeeDetailList.vue?vue&type=template&id=4b1780e2&scoped=true"
import script from "./reportOweFeeDetailList.vue?vue&type=script&lang=js"
export * from "./reportOweFeeDetailList.vue?vue&type=script&lang=js"
import style0 from "./reportOweFeeDetailList.vue?vue&type=style&index=0&id=4b1780e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1780e2",
  null
  
)

export default component.exports